export default __webpack_public_path__ + "static/media/experience.a1290b47.jpg";